(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-article-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Shared copy-link helper. React used navigator.clipboard + a 2s "Copied!" flag.
  // NEVER document.currentScript — section JS is bundled and it is null there.
  if (window.SRBShare) return;

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* clipboard unavailable */ }
    document.body.removeChild(ta);
  }

  function flash(btn) {
    var label = btn.querySelector('[data-srb-share-label]');
    var done = btn.getAttribute('data-label-done') || 'Copied!';
    var idle = btn.getAttribute('data-label-idle') || 'Share';
    btn.classList.add('is-copied');
    if (label) label.textContent = done;
    if (btn.__srbT) clearTimeout(btn.__srbT);
    btn.__srbT = setTimeout(function () {
      btn.classList.remove('is-copied');
      if (label) label.textContent = idle;
    }, 2000);
  }

  function onClick(e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-srb-share]') : null;
    if (!btn) return;
    var url = btn.getAttribute('data-url') || window.location.href;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { flash(btn); }, function () { fallbackCopy(url); flash(btn); });
    } else {
      fallbackCopy(url);
      flash(btn);
    }
  }

  function init() {
    if (document.documentElement.getAttribute('data-srb-share-bound') === '1') return;
    document.documentElement.setAttribute('data-srb-share-bound', '1');
    document.addEventListener('click', onClick);
  }

  window.SRBShare = { init: init };
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-calendar-content"] && !Shopify.designMode) return;
  try {
    
(function () {
  function api() {
    if (window.SRBCal) return window.SRBCal;
    var ROOT = document.documentElement;
    var defs = { content: 'All', sport: '', genre: '', view: 'grid' };
    function get(k) {
      var v = ROOT.getAttribute('data-srb-cal-' + k);
      return v === null ? defs[k] : v;
    }
    function state() {
      return { content: get('content'), sport: get('sport'), genre: get('genre'), view: get('view') };
    }
    function emit() {
      var st = state(), ev;
      try {
        ev = new CustomEvent('srb:calendar', { detail: st });
      } catch (e) {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent('srb:calendar', true, true, st);
      }
      document.dispatchEvent(ev);
    }
    function set(patch) {
      for (var k in patch) {
        if (Object.prototype.hasOwnProperty.call(patch, k)) ROOT.setAttribute('data-srb-cal-' + k, patch[k]);
      }
      emit();
    }
    function seed(k, v) {
      if (ROOT.getAttribute('data-srb-cal-' + k) === null) ROOT.setAttribute('data-srb-cal-' + k, v);
    }
    window.SRBCal = { get: get, state: state, set: set, emit: emit, seed: seed };
    return window.SRBCal;
  }

  function show(el, on) {
    if (!el) return;
    if (on) el.removeAttribute('hidden');
    else el.setAttribute('hidden', '');
  }

  function apply(root) {
    var S = api(), st = S.state(), i, j;
    var sportActive = (st.content === 'Games' && st.sport !== '');
    var dayVis = {};
    var listAny = false, gridAny = false;

    var days = root.querySelectorAll('[data-srb-day]');
    for (i = 0; i < days.length; i++) {
      var day = days[i];
      var date = day.getAttribute('data-date');
      var gameRows = day.querySelectorAll('[data-srb-game]');
      var musicRows = day.querySelectorAll('[data-srb-show]');

      var visGames = 0;
      for (j = 0; j < gameRows.length; j++) {
        var okG = !sportActive || gameRows[j].getAttribute('data-sport') === st.sport;
        show(gameRows[j], okG);
        if (okG) visGames++;
      }

      var hasGames = visGames > 0;
      var hasMusic = musicRows.length > 0;
      var genreOk;
      if (st.genre === '') {
        genreOk = hasMusic;
      } else {
        genreOk = false;
        for (j = 0; j < musicRows.length; j++) {
          var rowGenre = (musicRows[j].getAttribute('data-genre') || '').toLowerCase();
          if (rowGenre.indexOf(String(st.genre).toLowerCase()) !== -1) { genreOk = true; break; }
        }
      }

      var visible;
      if (st.content === 'Games') visible = hasGames;
      else if (st.content === 'Music') visible = genreOk;
      else visible = hasGames || hasMusic;

      show(day, visible);
      show(day.querySelector('[data-group="games"]'), st.content !== 'Music' && hasGames);
      show(day.querySelector('[data-group="music"]'), st.content !== 'Games' && hasMusic);

      var gBadge = day.querySelector('[data-games-badge]');
      show(gBadge, visGames > 0);
      var gCount = day.querySelector('[data-games-count]');
      if (gCount) gCount.textContent = String(visGames);
      var gWord = day.querySelector('[data-games-word]');
      if (gWord) {
        gWord.textContent = visGames === 1
          ? (gWord.getAttribute('data-one') || '')
          : (gWord.getAttribute('data-many') || '');
      }
      show(day.querySelector('[data-music-badge]'), hasMusic);

      dayVis[date] = visible;
      if (visible) listAny = true;
    }

    var cards = root.querySelectorAll('[data-srb-card]');
    for (i = 0; i < cards.length; i++) {
      var card = cards[i];
      var d2 = card.getAttribute('data-date');
      var kind = card.getAttribute('data-kind');
      var ok = Object.prototype.hasOwnProperty.call(dayVis, d2) ? dayVis[d2] : true;
      if (kind === 'game') {
        ok = ok && st.content !== 'Music' && (!sportActive || card.getAttribute('data-sport') === st.sport);
      } else {
        ok = ok && st.content !== 'Games';
      }
      show(card, ok);
      if (ok) gridAny = true;
    }

    var empty = root.querySelector('[data-srb-empty]');
    var isList = st.view === 'list';
    show(empty, isList ? !listAny : !gridAny);
  }

  function applyAll() {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = document.querySelectorAll('.srb-calendar-content');
    for (var i = 0; i < roots.length; i++) apply(roots[i]);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.srb-calendar-content');
    if (!roots.length) return;
    var S = api();
    S.seed('content', 'All');
    S.seed('sport', '');
    S.seed('genre', '');
    S.seed('view', roots[0].getAttribute('data-default-view') || 'grid');
    for (var i = 0; i < roots.length; i++) apply(roots[i]);
  }

  document.addEventListener('srb:calendar', applyAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-calendar-filter-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function api() {
    if (window.SRBCal) return window.SRBCal;
    var ROOT = document.documentElement;
    var defs = { content: 'All', sport: '', genre: '', view: 'grid' };
    function get(k) {
      var v = ROOT.getAttribute('data-srb-cal-' + k);
      return v === null ? defs[k] : v;
    }
    function state() {
      return { content: get('content'), sport: get('sport'), genre: get('genre'), view: get('view') };
    }
    function emit() {
      var st = state(), ev;
      try {
        ev = new CustomEvent('srb:calendar', { detail: st });
      } catch (e) {
        ev = document.createEvent('CustomEvent');
        ev.initCustomEvent('srb:calendar', true, true, st);
      }
      document.dispatchEvent(ev);
    }
    function set(patch) {
      for (var k in patch) {
        if (Object.prototype.hasOwnProperty.call(patch, k)) ROOT.setAttribute('data-srb-cal-' + k, patch[k]);
      }
      emit();
    }
    function seed(k, v) {
      if (ROOT.getAttribute('data-srb-cal-' + k) === null) ROOT.setAttribute('data-srb-cal-' + k, v);
    }
    window.SRBCal = { get: get, state: state, set: set, emit: emit, seed: seed };
    return window.SRBCal;
  }

  function sync(bar) {
    var S = api(), st = S.state(), i;
    bar.setAttribute('data-content', st.content);

    var pills = bar.querySelectorAll('[data-srb-cal-set]');
    for (i = 0; i < pills.length; i++) {
      var el = pills[i];
      var key = el.getAttribute('data-srb-cal-set');
      var val = el.getAttribute('data-value');
      var on = false;
      if (key === 'content') on = (val === st.content);
      else if (key === 'view') on = (val === st.view);
      else if (key === 'sport') on = (st.content === 'Games' && val === st.sport);
      else if (key === 'genre') on = (st.content === 'Music' && val === st.genre);
      if (on) el.classList.add('is-active'); else el.classList.remove('is-active');
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function bind(bar) {
    if (bar.getAttribute('data-srb-bound') === '1') return;
    bar.setAttribute('data-srb-bound', '1');
    var S = api();
    bar.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-srb-cal-set]') : null;
      if (!btn || !bar.contains(btn)) return;
      var patch = {};
      patch[btn.getAttribute('data-srb-cal-set')] = btn.getAttribute('data-value') || '';
      S.set(patch);
    });
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var bars = (scope || document).querySelectorAll('.srb-calendar-filters');
    if (!bars.length) return;
    var S = api();
    // The bar owns the merchant-chosen defaults, so it force-sets them once —
    // srb-calendar-content only ever seeds, so whichever script runs first the
    // bar's settings win. The guard stops a theme-editor reload from throwing
    // away the visitor's current selection.
    if (!window.__srbCalSeeded) {
      window.__srbCalSeeded = true;
      S.set({
        content: bars[0].getAttribute('data-default-content') || 'All',
        view: bars[0].getAttribute('data-default-view') || 'grid',
        sport: '',
        genre: ''
      });
    }
    for (var i = 0; i < bars.length; i++) {
      bind(bars[i]);
      sync(bars[i]);
    }
    S.emit();
  }

  function syncAll() {
    var bars = document.querySelectorAll('.srb-calendar-filters');
    for (var i = 0; i < bars.length; i++) sync(bars[i]);
  }

  document.addEventListener('srb:calendar', syncAll);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.srb-cart [data-qty], .srb-cart [data-remove]');
      if (!btn) return;
      var row = btn.closest('[data-line-key]');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var qtyEl = row.querySelector('.srb-cart__qtyval');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      var next = btn.hasAttribute('data-remove') ? 0 : qty + parseInt(btn.getAttribute('data-qty'), 10);
      if (next < 0) next = 0;
      btn.setAttribute('disabled', '');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function (r) { if (r.ok) { window.location.reload(); } else { btn.removeAttribute('disabled'); } })
        .catch(function () { btn.removeAttribute('disabled'); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-events-filter-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function apply(root, value) {
    var cards = root.querySelectorAll('[data-srb-ev-card]');
    var shown = 0, i;
    for (i = 0; i < cards.length; i++) {
      var cat = cards[i].getAttribute('data-category') || '';
      var on = (value === '' || cat === value);
      if (on) { cards[i].removeAttribute('hidden'); shown++; }
      else { cards[i].setAttribute('hidden', ''); }
    }
    var pills = root.querySelectorAll('[data-srb-ev-cat]:not([data-srb-ev-reset])');
    for (i = 0; i < pills.length; i++) {
      var on2 = (pills[i].getAttribute('data-srb-ev-cat') || '') === value;
      if (on2) { pills[i].classList.add('is-active'); } else { pills[i].classList.remove('is-active'); }
      pills[i].setAttribute('aria-pressed', on2 ? 'true' : 'false');
    }
    var empty = root.querySelector('[data-srb-ev-empty]');
    if (empty) {
      if (shown === 0) { empty.removeAttribute('hidden'); } else { empty.setAttribute('hidden', ''); }
    }
  }

  function bind(root) {
    if (root.getAttribute('data-srb-bound') === '1') return;
    root.setAttribute('data-srb-bound', '1');
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-srb-ev-cat]') : null;
      if (!btn || !root.contains(btn)) return;
      apply(root, btn.getAttribute('data-srb-ev-cat') || '');
    });
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = (scope || document).querySelectorAll('.srb-events-listing');
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
      apply(roots[i], '');
    }
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-events-signature-series"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setOpen(card, open) {
    var btn = card.querySelector('[data-srb-ss-toggle]');
    var txt = card.querySelector('[data-srb-ss-toggle-text]');
    if (open) { card.classList.add('is-open'); } else { card.classList.remove('is-open'); }
    if (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (txt) {
        txt.textContent = open
          ? (btn.getAttribute('data-label-open') || 'Less')
          : (btn.getAttribute('data-label-closed') || 'Details');
      }
    }
  }

  function bind(root) {
    if (root.getAttribute('data-srb-bound') === '1') return;
    root.setAttribute('data-srb-bound', '1');
    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-srb-ss-toggle]') : null;
      if (!btn || !root.contains(btn)) return;
      var card = btn.closest('[data-srb-ss-card]');
      if (!card) return;
      var willOpen = btn.getAttribute('aria-expanded') !== 'true';
      var cards = root.querySelectorAll('[data-srb-ss-card]');
      for (var i = 0; i < cards.length; i++) setOpen(cards[i], false);
      if (willOpen) setOpen(card, true);
    });
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = (scope || document).querySelectorAll('.srb-events-series');
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
      var cards = roots[i].querySelectorAll('[data-srb-ss-card]');
      for (var j = 0; j < cards.length; j++) setOpen(cards[j], false);
    }
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-events-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(root) {
    var slides = root.querySelectorAll('[data-srb-quote-slide]');
    var dots = root.querySelectorAll('[data-srb-quote-dot]');
    if (!slides.length) return;
    var current = 0;
    var timer = null;
    var paused = false;
    var startX = null;
    var interval = parseInt(root.getAttribute('data-autoplay') || '0', 10);

    function show(n) {
      current = (n + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        if (i === current) {
          slides[i].removeAttribute('hidden');
          slides[i].classList.remove('is-in');
          // force a reflow so the entry animation replays on every change
          void slides[i].offsetWidth;
          slides[i].classList.add('is-in');
        } else {
          slides[i].setAttribute('hidden', '');
          slides[i].classList.remove('is-in');
        }
      }
      for (var j = 0; j < dots.length; j++) {
        var on = j === current;
        if (on) { dots[j].classList.add('is-active'); } else { dots[j].classList.remove('is-active'); }
        dots[j].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!interval || paused || slides.length < 2) return;
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-srb-quote-prev]')) { show(current - 1); start(); return; }
      if (t.closest('[data-srb-quote-next]')) { show(current + 1); start(); return; }
      var dot = t.closest('[data-srb-quote-dot]');
      if (dot) { show(parseInt(dot.getAttribute('data-index') || '0', 10)); start(); }
    });

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () { paused = false; start(); });

    root.addEventListener('touchstart', function (e) {
      startX = e.touches && e.touches[0] ? e.touches[0].clientX : null;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var end = e.changedTouches && e.changedTouches[0] ? e.changedTouches[0].clientX : startX;
      var delta = end - startX;
      if (delta > 50) show(current - 1);
      else if (delta < -50) show(current + 1);
      startX = null;
      start();
    });

    show(0);
    start();
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = (scope || document).querySelectorAll('[data-srb-quotes]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].getAttribute('data-srb-bound') === '1') continue;
      roots[i].setAttribute('data-srb-bound', '1');
      setup(roots[i]);
    }
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-events-weekly-recurring"] && !Shopify.designMode) return;
  try {
    
(function () {
  function select(root, tab, focus) {
    var tabs = root.querySelectorAll('[data-srb-wk-tab]');
    var panels = root.querySelectorAll('[data-srb-wk-panel]');
    var i;
    for (i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
      if (on) { tabs[i].classList.add('is-active'); } else { tabs[i].classList.remove('is-active'); }
    }
    var id = tab.getAttribute('aria-controls');
    for (i = 0; i < panels.length; i++) {
      if (panels[i].id === id) { panels[i].removeAttribute('hidden'); }
      else { panels[i].setAttribute('hidden', ''); }
    }
    if (focus) tab.focus();
  }

  function bind(root) {
    if (root.getAttribute('data-srb-bound') === '1') return;
    root.setAttribute('data-srb-bound', '1');

    root.addEventListener('click', function (e) {
      var tab = e.target && e.target.closest ? e.target.closest('[data-srb-wk-tab]') : null;
      if (!tab || !root.contains(tab)) return;
      select(root, tab, false);
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target && e.target.closest ? e.target.closest('[data-srb-wk-tab]') : null;
      if (!tab || !root.contains(tab)) return;
      var tabs = [], all = root.querySelectorAll('[data-srb-wk-tab]');
      for (var i = 0; i < all.length; i++) tabs.push(all[i]);
      var idx = tabs.indexOf(tab), next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (idx + 1) % tabs.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (idx - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next < 0) return;
      e.preventDefault();
      select(root, tabs[next], true);
    });
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = (scope || document).querySelectorAll('.srb-events-week');
    for (var i = 0; i < roots.length; i++) {
      bind(roots[i]);
      var first = roots[i].querySelector('[data-srb-wk-tab][aria-selected="true"]') || roots[i].querySelector('[data-srb-wk-tab]');
      if (first) select(roots[i], first, false);
    }
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-gift-cards-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-gift-continue]');
      if (!btn) return;
      var scope = btn.closest('.srb-gift-form');
      var custom = scope && scope.querySelector('[data-gift-custom]');
      var base = btn.getAttribute('data-base');
      if (!base) return;
      // Custom amounts have no variant of their own: send the shopper to the
      // product page unfiltered so they pick/enter the value there.
      e.preventDefault();
      window.location.href = base;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-gift-wizard"] && !Shopify.designMode) return;
  try {
    
(function () {
  // The wizard is deliberately inert: it validates and reviews, it never posts.
  // NEVER document.currentScript — section JS is bundled and it is null there.
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function text(el, v) { if (el) el.textContent = v; }

  function setError(root, key, on) {
    var p = root.querySelector('[data-gift-error="' + key + '"]');
    if (p) {
      if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
    }
    var field = root.querySelector('[data-gift-field="' + key + '"]');
    if (field) field.setAttribute('aria-invalid', on ? 'true' : 'false');
  }

  function build(root) {
    if (root.getAttribute('data-srb-bound') === '1') return;
    root.setAttribute('data-srb-bound', '1');

    var panels = root.querySelectorAll('[data-gift-step]');
    var navs = root.querySelectorAll('[data-gift-goto]');
    var chips = root.querySelectorAll('[data-gift-amount]');
    var custom = root.querySelector('[data-gift-custom]');
    var contBtn = root.querySelector('[data-gift-next="2"]');
    var maxStep = 1;
    var i;

    function chosenAmount() {
      if (custom && custom.value && parseFloat(custom.value) > 0) {
        return (root.getAttribute('data-currency') || '$') + custom.value;
      }
      for (var k = 0; k < chips.length; k++) {
        if (chips[k].getAttribute('aria-pressed') === 'true') return chips[k].getAttribute('data-value') || '';
      }
      return '';
    }

    // The wizard itself sells nothing: it hands off to the real gift-card product
    // page. Carry the chosen denomination across as ?variant= so the shopper lands
    // on the right amount with one click, the way the old site behaved.
    var ctaEl = root.querySelector('[data-gift-cta]');
    function chosenVariant() {
      for (var v = 0; v < chips.length; v++) {
        if (chips[v].getAttribute('aria-pressed') === 'true') return chips[v].getAttribute('data-variant') || '';
      }
      return '';
    }
    function syncCta() {
      if (!ctaEl) return;
      var base = ctaEl.getAttribute('data-gift-base') || ctaEl.getAttribute('href') || '';
      if (!base) return;
      var id = chosenVariant();
      // A custom amount has no variant of its own -- send them to the product page
      // unfiltered rather than to a denomination they did not pick.
      ctaEl.setAttribute('href', id ? base + (base.indexOf('?') > -1 ? '&' : '?') + 'variant=' + encodeURIComponent(id) : base);
    }

    function refreshContinue() {
      if (!contBtn) return;
      if (chosenAmount()) { contBtn.removeAttribute('disabled'); } else { contBtn.setAttribute('disabled', ''); }
    }

    function show(step) {
      for (var p = 0; p < panels.length; p++) {
        var n = panels[p].getAttribute('data-gift-step');
        if (n === String(step)) { panels[p].removeAttribute('hidden'); } else { panels[p].setAttribute('hidden', ''); }
      }
      for (var n2 = 0; n2 < navs.length; n2++) {
        var num = parseInt(navs[n2].getAttribute('data-gift-goto'), 10);
        if (num === step) {
          navs[n2].classList.add('is-active');
          navs[n2].setAttribute('aria-current', 'step');
        } else {
          navs[n2].classList.remove('is-active');
          navs[n2].removeAttribute('aria-current');
        }
        if (num <= maxStep) {
          navs[n2].removeAttribute('aria-disabled');
        } else {
          navs[n2].setAttribute('aria-disabled', 'true');
        }
      }
    }

    function fill(key) {
      var f = root.querySelector('[data-gift-field="' + key + '"]');
      return f ? f.value.replace(/^\s+|\s+$/g, '') : '';
    }

    function summarise() {
      var dash = root.getAttribute('data-empty') || '—';
      var name = fill('recipient_name');
      var mail = fill('recipient_email');
      var who = name;
      if (mail) who = who ? name + ' · ' + mail : mail;
      text(root.querySelector('[data-gift-summary="amount"]'), chosenAmount() || dash);
      text(root.querySelector('[data-gift-summary="recipient"]'), who || dash);
      text(root.querySelector('[data-gift-summary="from"]'), fill('from_name') || dash);
      text(root.querySelector('[data-gift-summary="message"]'), fill('message') || dash);
    }

    function validateStep2() {
      var ok = true;
      var name = fill('recipient_name');
      var mail = fill('recipient_email');
      if (!name) { setError(root, 'recipient_name', true); ok = false; } else { setError(root, 'recipient_name', false); }
      if (!EMAIL.test(mail)) { setError(root, 'recipient_email', true); ok = false; } else { setError(root, 'recipient_email', false); }
      if (!ok) {
        var bad = root.querySelector('[aria-invalid="true"]');
        if (bad && bad.focus) bad.focus();
      }
      return ok;
    }

    function go(step) {
      if (step > maxStep) maxStep = step;
      show(step);
      if (step === 3) summarise();
    }

    for (i = 0; i < chips.length; i++) {
      chips[i].addEventListener('click', function () {
        for (var k = 0; k < chips.length; k++) {
          var on = chips[k] === this;
          chips[k].setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) { chips[k].classList.add('is-active'); } else { chips[k].classList.remove('is-active'); }
        }
        if (custom) custom.value = '';
        setError(root, 'amount', false);
        refreshContinue();
        syncCta();
      });
    }

    if (custom) {
      custom.addEventListener('input', syncCta);
    }
    if (custom) {
      custom.addEventListener('input', function () {
        if (custom.value) {
          for (var k = 0; k < chips.length; k++) {
            chips[k].setAttribute('aria-pressed', 'false');
            chips[k].classList.remove('is-active');
          }
        }
        setError(root, 'amount', false);
        refreshContinue();
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var next = t.closest('[data-gift-next]');
      if (next && root.contains(next)) {
        var target = parseInt(next.getAttribute('data-gift-next'), 10);
        if (target === 2) {
          if (!chosenAmount()) { setError(root, 'amount', true); return; }
          setError(root, 'amount', false);
          go(2);
        } else if (target === 3) {
          if (!validateStep2()) return;
          go(3);
        }
        return;
      }

      var back = t.closest('[data-gift-back]');
      if (back && root.contains(back)) {
        go(parseInt(back.getAttribute('data-gift-back'), 10));
        return;
      }

      var goto = t.closest('[data-gift-goto]');
      if (goto && root.contains(goto)) {
        if (goto.getAttribute('aria-disabled') === 'true') return;
        go(parseInt(goto.getAttribute('data-gift-goto'), 10));
      }
    });

    refreshContinue();
    syncCta();
    show(1);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.srb-gift-wizard');
    for (var i = 0; i < roots.length; i++) build(roots[i]);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Never scope via document.currentScript — Shopify bundles section JS into one
    // external file where it is null, which would silently kill the whole header.
    function init() {
      var header = document.querySelector('[data-srb-header]');
      if (!header || header.dataset.srbBound === '1') return;
      header.dataset.srbBound = '1';

      var threshold = parseInt(header.getAttribute('data-scrolled-at') || '40', 10);
      var progress = header.querySelector('[data-srb-progress]');
      var drawer = document.querySelector('[data-srb-drawer]');
      var burger = header.querySelector('[data-srb-burger]');
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* ---- scrolled state + progress hairline ---- */
      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var y = window.scrollY || document.documentElement.scrollTop;
          header.classList.toggle('is-scrolled', y > threshold);
          if (progress) {
            var max = document.documentElement.scrollHeight - window.innerHeight;
            progress.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
          }
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();

      /* ---- dropdowns: hover on pointer devices, click everywhere ---- */
      var closeTimer = null;
      var drops = header.querySelectorAll('[data-srb-drop]');

      function closeAll(except) {
        for (var i = 0; i < drops.length; i++) {
          if (drops[i] === except) continue;
          drops[i].classList.remove('is-open');
          var pn = drops[i].querySelector('[data-srb-drop-panel]');
          if (pn) pn.classList.remove('is-open');
          var t = drops[i].querySelector('[data-srb-drop-toggle]');
          if (t) { t.classList.remove('is-open'); t.setAttribute('aria-expanded', 'false'); }
        }
      }

      Array.prototype.forEach.call(drops, function (drop) {
        var toggle = drop.querySelector('[data-srb-drop-toggle]');

        function open() {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          closeAll(drop);
          drop.classList.add('is-open');
          var panel = drop.querySelector('[data-srb-drop-panel]');
          if (panel) panel.classList.add('is-open');
          if (toggle) { toggle.classList.add('is-open'); toggle.setAttribute('aria-expanded', 'true'); }
        }
        function close(delay) {
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            drop.classList.remove('is-open');
            var panel = drop.querySelector('[data-srb-drop-panel]');
            if (panel) panel.classList.remove('is-open');
            if (toggle) { toggle.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
          }, delay === undefined ? 200 : delay);   // matches React's 200ms grace period
        }

        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
          drop.addEventListener('mouseenter', open);
          drop.addEventListener('mouseleave', function () { close(200); });
        }
        if (toggle) {
          toggle.addEventListener('click', function (e) {
            e.preventDefault();
            if (drop.classList.contains('is-open')) close(0); else open();
          });
        }
        drop.addEventListener('focusin', open);
        drop.addEventListener('focusout', function (e) {
          if (!drop.contains(e.relatedTarget)) close(0);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeAll(null); closeDrawer(); }
      });
      document.addEventListener('click', function (e) {
        if (!header.contains(e.target)) closeAll(null);
      });

      /* ---- mobile drawer ---- */
      function openDrawer() {
        if (!drawer) return;
        drawer.removeAttribute('hidden');
        requestAnimationFrame(function () { drawer.classList.add('is-open'); });
        document.documentElement.classList.add('srb-drawer-open');
        if (burger) {
          burger.setAttribute('aria-expanded', 'true');
          // `hidden` is an HTMLElement property — a no-op expando on SVGElement,
          // so toggle the attribute instead.
          var o = burger.querySelector('.srb-header__burger-open');
          var c = burger.querySelector('.srb-header__burger-close');
          if (o) o.setAttribute('hidden', '');
          if (c) c.removeAttribute('hidden');
        }
      }
      function closeDrawer() {
        if (!drawer || drawer.hasAttribute('hidden')) return;
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('srb-drawer-open');
        if (burger) {
          burger.setAttribute('aria-expanded', 'false');
          var o = burger.querySelector('.srb-header__burger-open');
          var c = burger.querySelector('.srb-header__burger-close');
          if (o) o.removeAttribute('hidden');
          if (c) c.setAttribute('hidden', '');
        }
        setTimeout(function () { drawer.setAttribute('hidden', ''); }, reduced ? 0 : 400);
      }

      if (burger) {
        burger.addEventListener('click', function () {
          if (drawer && drawer.hasAttribute('hidden')) openDrawer(); else closeDrawer();
        });
      }
      if (drawer) {
        drawer.addEventListener('click', function (e) {
          if (e.target.closest('a')) closeDrawer();
        });
      }
      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1200) closeDrawer();
      }, { passive: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function () {
      var h = document.querySelector('[data-srb-header]');
      if (h) h.dataset.srbBound = '';
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-journal-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT = document.documentElement;
  var ATTR = 'data-srb-journal-cat';

  function norm(s) {
    return (s || '').toString().toLowerCase().replace(/^\s+|\s+$/g, '');
  }

  function allValue() {
    // NEVER document.currentScript here — section JS is bundled and it is null.
    var bar = document.querySelector('.srb-journal-filter');
    return bar ? (bar.getAttribute('data-all-value') || 'All') : 'All';
  }

  function current() {
    var v = ROOT.getAttribute(ATTR);
    return v === null ? allValue() : v;
  }

  function emit() {
    var ev;
    try {
      ev = new CustomEvent('srb:journal', { detail: { category: current() } });
    } catch (e) {
      ev = document.createEvent('CustomEvent');
      ev.initCustomEvent('srb:journal', true, true, { category: current() });
    }
    document.dispatchEvent(ev);
  }

  function tagsOf(card) {
    var raw = card.getAttribute('data-tags') || '';
    var out = raw.split('|');
    for (var i = 0; i < out.length; i++) out[i] = norm(out[i]);
    return out;
  }

  function apply() {
    var cat = current();
    var isAll = norm(cat) === norm(allValue());

    // Pills
    var pills = document.querySelectorAll('.srb-journal-filter [data-srb-journal-set]');
    for (var i = 0; i < pills.length; i++) {
      var on = norm(pills[i].getAttribute('data-value')) === norm(cat);
      if (on) { pills[i].classList.add('is-active'); } else { pills[i].classList.remove('is-active'); }
      pills[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    // React only renders the Featured band while the filter is "All".
    var feat = document.querySelectorAll('.srb-journal-featured');
    for (var f = 0; f < feat.length; f++) {
      if (isAll) { feat[f].removeAttribute('hidden'); } else { feat[f].setAttribute('hidden', ''); }
    }

    // Grid cards. React: on "All" the grid drops posts already shown as featured;
    // on a category it shows every post in that category, featured included.
    var grids = document.querySelectorAll('.srb-journal-posts');
    for (var g = 0; g < grids.length; g++) {
      var cards = grids[g].querySelectorAll('[data-srb-journal-card]');
      var visible = 0;
      for (var c = 0; c < cards.length; c++) {
        var card = cards[c];
        var show;
        if (isAll) {
          show = card.getAttribute('data-featured') !== 'true';
        } else {
          show = tagsOf(card).indexOf(norm(cat)) !== -1;
        }
        if (show) { card.removeAttribute('hidden'); visible++; } else { card.setAttribute('hidden', ''); }
      }
      var empty = grids[g].querySelector('[data-srb-journal-empty]');
      if (empty) {
        if (visible === 0) { empty.removeAttribute('hidden'); } else { empty.setAttribute('hidden', ''); }
      }
      var pager = grids[g].querySelector('[data-srb-journal-pagination]');
      if (pager) {
        if (isAll) { pager.removeAttribute('hidden'); } else { pager.setAttribute('hidden', ''); }
      }
    }
  }

  function bind(bar) {
    if (bar.getAttribute('data-srb-bound') === '1') return;
    bar.setAttribute('data-srb-bound', '1');
    bar.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-srb-journal-set]') : null;
      if (!btn || !bar.contains(btn)) return;
      ROOT.setAttribute(ATTR, btn.getAttribute('data-value') || allValue());
      emit();
    });
  }

  function init() {
    var bars = document.querySelectorAll('.srb-journal-filter');
    if (!bars.length) return;
    if (ROOT.getAttribute(ATTR) === null) ROOT.setAttribute(ATTR, allValue());
    for (var i = 0; i < bars.length; i++) bind(bars[i]);
    apply();
  }

  document.addEventListener('srb:journal', apply);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-live-roster"] && !Shopify.designMode) return;
  try {
    
(function () {
  function apply(root) {
    var active = root.getAttribute('data-active-genre') || '';
    var needle = active.toLowerCase();
    var cards = root.querySelectorAll('[data-srb-artist]');
    var visible = 0;
    for (var i = 0; i < cards.length; i++) {
      var genre = (cards[i].getAttribute('data-genre') || '').toLowerCase();
      var ok = needle === '' || genre.indexOf(needle) !== -1;
      if (ok) { cards[i].removeAttribute('hidden'); visible++; }
      else { cards[i].setAttribute('hidden', ''); }
    }
    var buttons = root.querySelectorAll('[data-srb-genre]');
    for (var j = 0; j < buttons.length; j++) {
      var on = (buttons[j].getAttribute('data-srb-genre') || '') === active;
      if (on) buttons[j].classList.add('is-active');
      else buttons[j].classList.remove('is-active');
      buttons[j].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var empty = root.querySelector('[data-srb-roster-empty]');
    if (empty) {
      if (visible === 0 && cards.length > 0) empty.removeAttribute('hidden');
      else empty.setAttribute('hidden', '');
    }
  }

  function bind(root) {
    if (root.getAttribute('data-srb-bound') === 'true') { apply(root); return; }
    root.setAttribute('data-srb-bound', 'true');

    var first = root.querySelector('[data-srb-genre]');
    if (root.getAttribute('data-active-genre') === null) {
      root.setAttribute('data-active-genre', first ? (first.getAttribute('data-srb-genre') || '') : '');
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== root && !t.hasAttribute('data-srb-genre')) t = t.parentNode;
      if (!t || t === root) return;
      root.setAttribute('data-active-genre', t.getAttribute('data-srb-genre') || '');
      apply(root);
    });

    apply(root);
  }

  function init(scope) {
    // NEVER document.currentScript — section JS is bundled and it is null there.
    var roots = (scope || document).querySelectorAll('.srb-live-roster');
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-menus-filter-search"] && !Shopify.designMode) return;
  try {
    
/* Menus filter + search.
   Scoped by querying the document — NEVER document.currentScript, which is null
   once Shopify bundles section JS into one external file. */
(function () {
  var state = { filter: 'all', query: '' };

  function pills() {
    return document.querySelectorAll('[data-srb-menu-filter]');
  }

  function syncPills() {
    var list = pills();
    for (var i = 0; i < list.length; i++) {
      var on = list[i].getAttribute('data-srb-menu-filter') === state.filter;
      list[i].classList.toggle('is-active', on);
      list[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
  }

  function apply() {
    var groups = document.querySelectorAll('[data-srb-menu-group]');
    if (!groups.length) return;

    var q = state.query.trim().toLowerCase();
    var totalVisible = 0;
    var visibleGroups = [];

    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var cat = group.getAttribute('data-srb-cat') || '';
      var catOn = state.filter === 'all' || cat === state.filter;

      var items = group.querySelectorAll('[data-srb-menu-item]');
      var shown = 0, minP = 0, maxP = 0, idx = 0;

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var hay = item.getAttribute('data-srb-search') || '';
        var match = catOn && (!q || hay.indexOf(q) > -1);
        item.classList.toggle('srb-menu-hidden', !match);
        if (!match) continue;
        shown++;
        idx++;
        var num = item.querySelector('[data-srb-item-index]');
        if (num) num.textContent = idx < 10 ? '0' + idx : String(idx);
        var p = parseInt(item.getAttribute('data-srb-price') || '0', 10);
        if (p > 0) {
          if (minP === 0 || p < minP) minP = p;
          if (p > maxP) maxP = p;
        }
      }

      var groupOn = catOn && shown > 0;
      group.classList.toggle('srb-menu-hidden', !groupOn);
      if (groupOn) {
        totalVisible += shown;
        visibleGroups.push(group);
      }

      var countEl = group.querySelector('[data-srb-cat-count]');
      if (countEl) countEl.textContent = String(shown);

      var rangeWrap = group.querySelector('[data-srb-cat-range]');
      if (rangeWrap) {
        var rangeVal = rangeWrap.querySelector('[data-srb-cat-range-value]');
        if (minP > 0 && rangeVal) {
          rangeVal.textContent = minP === maxP ? '$' + minP : '$' + minP + '–$' + maxP;
          rangeWrap.classList.remove('srb-menu-hidden');
        } else {
          rangeWrap.classList.add('srb-menu-hidden');
        }
      }
    }

    /* Gold divider sits between groups only — never after the last visible one. */
    for (var v = 0; v < visibleGroups.length; v++) {
      var div = visibleGroups[v].querySelector('[data-srb-menu-divider]');
      if (div) div.classList.toggle('srb-menu-hidden', v === visibleGroups.length - 1);
    }

    var empties = document.querySelectorAll('[data-srb-menu-empty]');
    for (var e = 0; e < empties.length; e++) {
      var empty = empties[e];
      empty.classList.toggle('srb-menu-hidden', totalVisible !== 0);
      var txt = empty.querySelector('[data-srb-menu-empty-text]');
      if (txt) {
        var tpl = txt.getAttribute('data-srb-menu-empty-text') || '';
        txt.textContent = tpl.replace('[query]', state.query);
      }
    }
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest && e.target.closest('[data-srb-menu-filter]');
    if (!pill) return;
    e.preventDefault();
    state.filter = pill.getAttribute('data-srb-menu-filter') || 'all';
    syncPills();
    apply();
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('[data-srb-menu-search]');
    if (!input) return;
    state.query = input.value || '';
    apply();
  });

  function boot() { syncPills(); apply(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srb-product-gift-card"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-sendto]');
      if (!btn) return;
      var scope = btn.closest('.srb-pgc');
      if (!scope) return;
      var btns = scope.querySelectorAll('[data-sendto]');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-selected', btns[i] === btn);
      var fields = scope.querySelector('[data-recipient-fields]');
      var show = btn.getAttribute('data-sendto') === 'recipient';
      if (fields) { if (show) { fields.removeAttribute('hidden'); } else { fields.setAttribute('hidden', ''); } }
      var email = scope.querySelector('[data-recipient-email]');
      if (email) { if (show) { email.setAttribute('required', ''); } else { email.removeAttribute('required'); email.value = ''; } }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
